const NUM_OF_ERA_IN_ROW = 2;
const NUM_OF_YEAR_IN_GRID = 20;
const NUM_OF_YEAR_IN_ROW = 4;
const NUM_OF_MONTH_IN_ROW = 3;
const NUM_OF_DAY_IN_ROW = 7;
const NUM_OF_ROWS_OF_DAYS = 6;
const NUM_OF_DAYS_IN_GRID = NUM_OF_DAY_IN_ROW * NUM_OF_ROWS_OF_DAYS;

export {
  NUM_OF_DAY_IN_ROW,
  NUM_OF_DAYS_IN_GRID,
  NUM_OF_ERA_IN_ROW,
  NUM_OF_MONTH_IN_ROW,
  NUM_OF_YEAR_IN_GRID,
  NUM_OF_YEAR_IN_ROW};
